import numeral from 'numeral';

// load a locale
numeral.register('locale', 'vi', {
    delimiters: {
        thousands: '.',
        decimal: ',',
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't',
    },
    ordinal: function (number: number) {
        return `${number}`;
    },
    currency: {
        symbol: 'VND',
    },
});

// switch between locales
numeral.locale('vi');

export default numeral;
